<template>
  <div>
    <modal :show.sync="modals.submit" class="modal-eprf" centered>
      <div class="row">
        <div class="col-lg text-center">
          <img src="@/assets/img/tick.png" width="300" />
          <br />
          <br />
          <br />
          <h1>JOB REQUEST SUCCESSFULLY SUBMITTED</h1>
          <p>
            Our Customer Relations Officer will be in touch with you within 24
            hours
          </p>
          <br />
          <base-button type="warning" v-on:click="getDone()"
              >Done</base-button
            >
        </div>
      </div>
    </modal>

    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-lg"></div>
          <div class="col-lg-6">
            <card class="card-eprf-declare">
              <div class="row">
                <!-- <div class="col-lg-1"> -->
                <input
                  style="border: 1px solid #707070"
                  type="checkbox"
                  class="rounded-checkbox"
                  v-model="declare"
                  value="0"
                />
                <!-- </div> -->
                <div class="col-lg">
                  I hereby confirm that the provided details above are correct
                  and accurate. If not delivering all waste to this facility, I
                  confirm that there is sufficient dedicated on-board capacity
                  to store all waste generated between this notification and the
                  next port at which waste will be delivered. In addition, I
                  declare that the following are true for waste to be delivered
                  to this facility:
                </div>
              </div>
              <div class="row">
                <div class="col-lg"></div>
                <div class="col-lg-11">
                  <br /><br />
                  • No illegal transboundary waste originating from another
                  country
                  <br />
                  • No radioactive waste
                  <br />
                  • No clinical waste
                  <br />
                  • No explosive waste
                </div>
                <div class="col-lg"></div>
              </div>
            </card>
          </div>
          <div class="col-lg"></div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-lg"></div>
          <div class="col-lg-3 text-right">
            <base-button
              wide
              type="danger"
              @click.native="prevTab"
              class="btn-dispute"
            >
              Back
            </base-button>

            &nbsp;

            <!-- <base-button
              type="primary"
              wide
              @click.native="submitDeclaration"
              class="btn-next"
            >
              Submit
            </base-button> -->

            <base-button :disabled="!declare" type="primary" v-on:click="submitDeclaration()"
              >Submit</base-button
            >
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-lg"></div>
          <div class="col-lg-3 text-right">
            <!-- @click="saveDraft()" -->
            <base-button
            class="btn-link"
              style="
                color: #052d72;
                cursor: pointer;
                text-decoration: underline;
              "
             disabled
            >
              Save Draft
          </base-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Alert } from "element-ui";
import swal from "sweetalert2";
// import Card from "../../../components/Cards/Card.vue";
import Calendar from "src/components/Calendar/Calendar.vue";
// import Calendar from "src/components/Calendar/CalendarCustom.vue";
import { Modal } from "src/components";

export default {
  components: {
    // Card,
    Calendar,
    Modal,
  },

  data() {
    return {
      modals: {
        declare: false,
        submit: false,
      },

      declare: false,

      jobno: "",
      demoEvents: [
        {
          title: "Sunny Out of Office",
          start: "2024-01-15",
          end: "2024-01-15",
          time: "09:00",
          cssClass: ["delay"],
        },
        {
          title: "Sunny Out of Office",
          start: "2024-01-15",
          end: "2024-01-15",
          time: "09:00",
          cssClass: ["delay"],
        },
        {
          title: "Sunny Out of Office",
          start: "2024-01-15",
          end: "2024-01-15",
          time: "09:00",
          cssClass: ["delay"],
        },
        {
          title: "Sunny Out of Office",
          start: "2024-01-15",
          end: "2024-01-15",
          time: "09:00",
          cssClass: ["delay"],
        },
        {
          title: "Sunny Out of Office",
          start: "2024-01-15",
          end: "2024-01-15",
          time: "09:00",
          cssClass: ["delay"],
        },
        {
          title: "Sunny Out of Office qwertyuiop",
          start: "2024-01-14",
          end: "2024-01-14",
          time: "09:00",
          cssClass: ["delay"],
        },

        {
          title: "hewwo",
          start: "2024-01-20",
          end: "2024-01-20",
          time: "13:00",
          cssClass: ["onschedule"],
        },
      ],
    };
  },
  mounted() {
    // this.jobno = sessionStorage.getItem("jobnum");
    this.jobno = this.$route.params.jobnum;
  },
  methods: {
    getDone() {
      this.$router.push("/Vessel/Request");
    },
    submitData() {
      this.modals.submit = true;
      // setTimeout(() => {
      //   this.modals.submit = false;
      //   this.$router.push("/Vessel/Request");
      // }, 1500);

      // this.submit = true;
    },
    submitDeclaration() {
      this.$http
        .post(":10001/api/v1/incoming/" + this.jobno + "/do/accept")
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log("declare jadi");
            this.submitData();
          } else {
            console.log("declare xjadi");
            swal({
              title: "Failed!",
              text: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
          }
        });
    },
    prevTab() {
      console.log("prev");
      let parameter = {
        step: "3",
        direction: "blkg",
        data: [],
      };
      this.$emit("my-event", parameter);
    },

    getDownload() {},

    validate() {
      // if(this.imagebase64 == "" || this.images.regular == null){
      //     swal({
      //         title: "Data Error!",
      //         text: "All data must be filled in.",
      //         type: "warning",
      //         confirmButtonClass: "btn btn-success btn-fill",
      //         buttonsStyling: false,
      //     });
      // } else {
      return this.$validator.validateAll().then((res) => {
        this.$root.$emit("image", this.imagebase64);
        return res;
      });
      // }
    },
  },
  created() {},
  computed: {},
};
</script>
<style>
.comp-full-calendar {
  min-width: none !important;
  max-width: none !important;
  width: 100%;
  /* background: red; */
}

.header-center {
  text-align: right !important;
}

.header-right {
  display: none;
}
.day-cell .day-number {
  color: #A5A5A5;
}
.day-cell .not-cur-month {
  color: #A5A5A5 !important;
  opacity: 0.5;
}
</style>
